<template>
  <span class="ScannerImagesButton" v-if="images && images.length">
    <b-tooltip v-if="images.length === 1" label="צפה בסריקת הדוח">
      <a href="#" class="ScannerImagesButton__Icon" @click.prevent="open(images[0])">
        <b-icon icon="image" />
      </a>
    </b-tooltip>
    <b-dropdown position="is-bottom-right" v-else aria-role="list">
      <template #trigger>
        <b-tooltip label="צפה בסריקות הדוח">
          <a href="#" class="ScannerImagesButton__Icon" @click.prevent>
            <b-icon icon="image" />
            <span class="ScannerImagesButton__Count">{{ images.length }}</span>
          </a>
        </b-tooltip>
      </template>
      <b-dropdown-item class="ScannerImagesDrop" v-for="(image, index) in images" :key="image.Id" aria-role="listitem" @click="open(image)">
        סריקה {{ index + 1 }} · {{ formatDate(image.CreateDate) }}
      </b-dropdown-item>
    </b-dropdown>
  </span>
</template>

<script>
import moment from "moment";
import { ToastProgrammatic as Toast } from "buefy";
import FilesService from "@/services/FilesService";

const FALLBACK_FILE_NAME = "סריקת דוח";

// The documents the BetterWayScanner uploaded for a report (admin only). Each one is fetched with the
// auth token: pdf/images open in a new tab, other files (docx) are downloaded.
export default {
  name: "ScannerImagesButton",
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    open(image) {
      FilesService.openFileInNewTab(image.Url, FALLBACK_FILE_NAME).catch(() => {
        Toast.open({
          type: "is-danger",
          message: "המערכת נתקלה בבעיה! יש לנסות שוב או לפנות לתמיכה הטכנית.",
          position: "is-bottom",
          duration: 8000,
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.ScannerImagesButton{
  margin-left: 8px;
}
.ScannerImagesButton ::v-deep .dropdown-menu{
  min-width: 0;   // as wide as the longest item, instead of Bulma's 12rem
}
.ScannerImagesButton__Icon {
  display: inline-flex;
  align-items: center;
  color: #0091ae;
  font-size: 14px;
}

.ScannerImagesButton__Count {
  font-size: 12px;
  font-weight: bold;
}
.ScannerImagesDrop{
  direction: rtl;          // Hebrew order: "סריקה 1 · 18/10/2026" reads right-to-left
  text-align: right;       // text starts at the right edge
  padding: 0.3rem 0.5rem;  // even padding instead of Bulma's 3rem on the right
}
</style>
